import { TokenMetadata } from "@renec-foundation/relend-adapter"
import { atom } from "jotai"

export const metadataAtom = atom<TokenMetadata>({})
